import Vue from "vue";
import Vuex from "vuex";
import SAMAN_CONFIG from "../global-config";
import jwt_decode from "jwt-decode";

Vue.use(Vuex);

const mutations = {
  setAccessToken(state, token) {
    state.authentication.accessToken = token;
  }
};

function isValidAccessToken(token) {
  try {
    const decoded = jwt_decode(token.replace("Bearer ", ""));
    const now = Math.floor(Date.now() / 1000);
    return decoded.exp && decoded.exp > now;
  } catch (e) {
    return false;
  }
}

export default new Vuex.Store({
  state: {
    sideBarIsSmall: window.localStorage.getItem("sideBarIsSmall") === "true",
    server_address: SAMAN_CONFIG.api,
    authentication: {
      accessToken: null,
      username: null,
      adminGroups: null
    },
    breadCrumbs: {}
  },
  getters: {
    getAccessToken: state => state.authentication.accessToken,
    getServerAddress: state => state.server_address,
    isAuthenticated: state => isValidAccessToken(state.authentication.accessToken)
  },
  mutations
});
